import React, { useEffect } from "react";
import { useAuthStatus } from "@/contexts/OptimizedAuthContext";
import { redirectToLogin } from "@/lib/utils/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuthStatus();

  useEffect(() => {
    // When user is authenticated, always set preference to "signin"
    // Rationale: If they successfully authenticated, they're now a returning user
    // Next time they visit /auth, they'll want to sign in, not sign up again
    if (isLoaded && isSignedIn) {
      localStorage.setItem("auth_last_method", "signin");
    }
  }, [isLoaded, isSignedIn]);

  if (!isLoaded) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (!isSignedIn) {
    // Redirect to /auth with a push state, move current path in get parameter
    redirectToLogin();
    return <></>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
